import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import { useElementOverflow } from "~/hooks/useElementOverflow";
import { cn } from "~/lib/utils";
import { MetadataSection } from "~/molecules/DocumentMetadataSections";
import { RichTextView } from "~/molecules/RichTextView";

interface Props {
  description: string | null;
}

export default function WorkflowDescription({ description }: Props) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const { ref: descriptionRef, isOverflowing: isDescriptionTruncated } =
    useElementOverflow<HTMLDivElement>();

  return (
    <MetadataSection title={t(($) => $.commons.workflow.description)}>
      {description ? (
        <>
          <RichTextView
            ref={descriptionRef}
            value={description}
            className={cn("text-xs", { "line-clamp-4": !expanded })}
          />
          {isDescriptionTruncated || expanded ? (
            <div className="flex justify-center">
              <Button variant="link" onClick={() => setExpanded(!expanded)}>
                {expanded
                  ? t(($) => $.commons.buttons.collapse)
                  : t(($) => $.commons.buttons.expand)}
              </Button>
            </div>
          ) : null}
        </>
      ) : (
        <p className="text-muted-foreground text-sm">-</p>
      )}
    </MetadataSection>
  );
}
